import { FirstCategoryLevel, FetchAttr } from '../types';
import { getData } from '../utils';

export type GetCategoriesResponse = FirstCategoryLevel[];

const getMultyLevelCategories = async (
  attr?: FetchAttr
): Promise<GetCategoriesResponse> => {
  const response = await getData(`categories/tree`, attr);
  return response;
};

export default getMultyLevelCategories;
